export const ADD_PAGE = 'Tilføj afsnit...';
export const ADD_PAGE_PLACEHOLDER = 'Skriv en titel';
